var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 57,
    viewBox: "0 0 76 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.056 41.0735L38.173 19.7795C37.491 19.3855 36.39 19.3885 35.718 19.7795L31.597 22.1745L27.449 19.7795C26.767 19.3855 25.666 19.3885 24.994 19.7795L1.00601 33.7195C0.328012 34.1135 0.332008 34.7475 1.01401 35.1415L37.897 56.4355C38.238 56.6325 38.682 56.7305 39.126 56.7305H49.848C50.293 56.7315 50.738 56.6325 51.078 56.4355L75.066 42.4955C75.737 42.1045 75.739 41.4675 75.056 41.0735Z",
    fill: "#615A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2277 32.3005L11.2217 34.4255C11.2207 34.6845 11.3927 34.9435 11.7357 35.1415L48.6177 56.4355C49.2997 56.8295 50.3947 56.8295 51.0727 56.4355L75.0607 42.4955C75.3957 42.3015 75.5637 42.0456 75.5647 41.7896L75.5707 39.6646L11.2277 32.3005Z",
    fill: "url(#paint0_linear_1949_43690)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0585 38.9485L38.1765 17.6545C37.4945 17.2605 36.3935 17.2635 35.7215 17.6545L11.7336 31.5945C11.0556 31.9885 11.0595 32.6225 11.7415 33.0165L48.6236 54.3105C49.3055 54.7045 50.4006 54.7045 51.0786 54.3105L75.0665 40.3705C75.7395 39.9795 75.7415 39.3425 75.0585 38.9485Z",
    fill: "#FFCB27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M38.1765 17.6545C37.4945 17.2605 36.3935 17.2635 35.7215 17.6545L11.7336 31.5945C11.0556 31.9885 11.0595 32.6225 11.7415 33.0165L44.9715 52.7595L47.2305 53.5065H49.8905L38.1765 17.6545Z",
    fill: "#BC7400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6574 17.8923L12.6514 32.0633C12.6504 32.3223 12.8224 32.5813 13.1654 32.7793L48.6184 53.2483C49.3004 53.6423 50.3954 53.6423 51.0734 53.2483L73.7064 40.0903C74.0414 39.8963 74.2094 39.6403 74.2104 39.3833L74.2164 25.2123L12.6574 17.8923Z",
    fill: "url(#paint1_linear_1949_43690)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7448 41.7623L71.2998 41.5053V26.4663L71.7448 26.7233V41.7623Z",
    fill: "#BC7400"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4591 40.7724L71.7451 41.7624V26.7234L73.4591 25.7334V40.7724Z",
    fill: "#E69F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7448 26.7233L71.2998 26.4663L73.0138 25.4773L73.4588 25.7333L71.7448 26.7233Z",
    fill: "#E69F00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4997 47.1005L62.0547 46.8434V31.8044L62.4997 32.0615V47.1005Z",
    fill: "#BC7400"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.213 46.1105L62.5 47.1005V32.0615L64.213 31.0725V46.1105Z",
    fill: "#E69F00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4997 32.0614L62.0547 31.8044L63.7687 30.8154L64.2127 31.0724L62.4997 32.0614Z",
    fill: "#E69F00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2536 52.4383L52.8086 52.1813V37.1423L53.2536 37.3993V52.4383Z",
    fill: "#BC7400"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9679 51.4484L53.2539 52.4384V37.3994L54.9679 36.4104V51.4484Z",
    fill: "#E69F00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2536 37.3993L52.8086 37.1423L54.5226 36.1533L54.9676 36.4103L53.2536 37.3993Z",
    fill: "#E69F00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6191 41.6282L28.0631 41.3712V26.3333L27.6191 26.5902V41.6282Z",
    fill: "#CF8800"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9053 40.6393L27.6193 41.6283V26.5903L25.9053 25.6003V40.6393Z",
    fill: "#BC7400"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6193 26.5903L28.0633 26.3333L26.3503 25.3433L25.9053 25.6003L27.6193 26.5903Z",
    fill: "#E69F00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8643 46.9662L37.3092 46.7101V31.6711L36.8643 31.9282V46.9662Z",
    fill: "#CF8800"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1514 45.9772L36.8644 46.9662V31.9283L35.1514 30.9382V45.9772Z",
    fill: "#BC7400"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8644 31.9282L37.3094 31.6711L35.5954 30.6812L35.1514 30.9381L36.8644 31.9282Z",
    fill: "#E69F00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1104 52.3043L46.5553 52.0483V37.0093L46.1104 37.2663V52.3043Z",
    fill: "#CF8800"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3965 51.3154L46.1105 52.3044V37.2664L44.3965 36.2764V51.3154Z",
    fill: "#BC7400"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1105 37.2663L46.5555 37.0093L44.8415 36.0203L44.3965 36.2763L46.1105 37.2663Z",
    fill: "#E69F00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3652 36.2864L18.8102 36.0294V20.9915L18.3652 21.2474V36.2864Z",
    fill: "#CF8800"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6514 35.2965L18.3654 36.2865V21.2475L16.6514 20.2585V35.2965Z",
    fill: "#BC7400"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3654 21.2474L18.8104 20.9915L17.0964 20.0015L16.6514 20.2585L18.3654 21.2474Z",
    fill: "#E69F00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2277 14.9414L11.2217 17.0664C11.2207 17.3254 11.3927 17.5844 11.7357 17.7824L48.6177 39.0764C49.2997 39.4704 50.3947 39.4704 51.0727 39.0764L75.0607 25.1364C75.3957 24.9414 75.5637 24.6864 75.5647 24.4294L75.5707 22.3044L11.2277 14.9414Z",
    fill: "url(#paint2_linear_1949_43690)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0585 21.5884L38.1765 0.294376C37.4945 -0.0996239 36.3935 -0.0966239 35.7215 0.294376L11.7336 14.2344C11.0556 14.6284 11.0595 15.2624 11.7415 15.6564L48.6236 36.9504C49.3055 37.3444 50.4006 37.3444 51.0786 36.9504L75.0665 23.0104C75.7395 22.6204 75.7415 21.9824 75.0585 21.5884Z",
    fill: "#FFCB27"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4036 21.5883L38.1846 1.25434C37.5026 0.860337 36.4016 0.863337 35.7296 1.25434L13.3976 14.2383C12.7196 14.6323 12.7236 15.2663 13.4056 15.6603L48.6246 35.9943C49.3066 36.3883 50.4016 36.3883 51.0796 35.9943L73.4116 23.0103C74.0836 22.6203 74.0856 21.9823 73.4036 21.5883Z",
    fill: "url(#paint3_linear_1949_43690)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0797 35.9954L58.5487 31.6534L38.1847 19.8964C37.5027 19.5024 36.4017 19.5054 35.7297 19.8964L28.2607 24.2384L48.6247 35.9954C49.3067 36.3894 50.4017 36.3894 51.0797 35.9954Z",
    fill: "#FFCB27"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1949_43690",
    x1: 48.3573,
    y1: 44.5156,
    x2: 51.2389,
    y2: 44.5156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1949_43690",
    x1: 48.18,
    y1: 35.7177,
    x2: 50.9369,
    y2: 35.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1949_43690",
    x1: 48.3573,
    y1: 27.1563,
    x2: 51.2389,
    y2: 27.1563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1949_43690",
    x1: 38.9799,
    y1: 18.6256,
    x2: 34.7051,
    y2: 18.6256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69F00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.2f849492e828bcfd6977dcd632f78fb7.svg";
export { ForwardRef as ReactComponent };